import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import BootstrapTable from 'react-bootstrap-table-next';
import Spinner from 'react-bootstrap/Spinner';
import * as apiUtility from "../../config/APIUtils";
import { IconButton, Paper, Tooltip, Button, Box, Typography } from "@mui/material";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import ErrorPopUp from '../Utility/ErrorPopUp';
import { RiFileExcel2Line } from "react-icons/ri";
import { BsFiletypePdf } from "react-icons/bs";

function OrganizationTemplateSpecificComponent(props) {
    const [orgStaffSummData, setOrgStaffSummData] = useState([]);
    const [showSpinner, setshowSpinner] = useState(false);
    const toggleshowSpinner = () => setshowSpinner(!showSpinner);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');

    var orgId = props.org_id;
    var filterObj = props.filterBy;
    var homeFlag = props.homeFlag;
    var staffFlag = props.staffFlag;
    var roleId = props.roleId;
    var crsPolicyType = props.crsPolicyType;
    useEffect(() => {
        let mounted = true;
        const fetchData = async () => {
            setshowSpinner(true);
            try {
                const body = {
                    orgId: orgId,
                    firstName: filterObj?.firstName || "",
                    lastName: filterObj?.lastName || "",
                    homeFlag: homeFlag,
                    staffFlag: staffFlag,
                    crsPolicyType:crsPolicyType, 
                    roleId: roleId || 0
                };
               
                const apiRequest1 = apiUtility.apiInputRequest;
                apiRequest1.endPoint = "audit-report/org-policy-template-specific";
                apiRequest1.data = body;
                const res1 = await apiUtility.sendAPIDataPOST(apiRequest1);
                 const apiRequest = apiUtility.apiInputRequest;
                apiRequest.endPoint = "audit-report/org-template-specific";
                apiRequest.data = body;
                const res = await apiUtility.sendAPIDataPOST(apiRequest);                
                if (!mounted) return;
                const data = Array.isArray(res.data) ? res.data : [];
                const data1 = Array.isArray(res1.data) ? res1.data : [];
                 const len1 = data?.length || 0;
                const len2 = data1?.length || 0;
                const maxLen = Math.max(len1, len2);
                var finalArr=[];
                console.log("props in audit report------>",props)
                 if(props.crsPolicyType && props.crsPolicyType=='11'){
                    console.log("Here1-->")
                    for (let i = 0; i < maxLen; i++) {
                if (i < len1) {
                    res.data[i]['type'] = 'Course';
                    finalArr.push(res.data[i]);
                }
                if (i < len2) {
                    res1.data[i]['type'] = 'Home Doc';
                    finalArr.push(res1.data[i]);
                }
                }
                }
                else if(props.crsPolicyType && props.crsPolicyType=='10'){
                    console.log("Here2-->")
                    for (let i = 0; i < len2; i++) {
                    res1.data[i]['type'] = 'Home Doc';
                    finalArr.push(res1.data[i]);
                    }
                }
                else if(props.crsPolicyType && props.crsPolicyType=='9'){
                    console.log("Here3-->")
                    for (let i = 0; i < len1; i++) {
                    res.data[i]['type'] = 'Course';
                    finalArr.push(res.data[i]);
                    }
                }

                // normalize dates safely
                finalArr.forEach((item, index) => {
                    if (item && item.completion_date) {
                        const d = new Date(item.completion_date);
                        finalArr[index].completion_date = isNaN(d.getTime()) ? item.completion_date : d.toLocaleString();
                    }
                });
                setOrgStaffSummData(finalArr);
            } catch (error) {
                console.error("Error fetching template specific data:", error);
                setDataForErrorPopup("No Data avaialble. Please try again.");
                setShowErrorPopup(true);
                setOrgStaffSummData([]); // ensure empty on error
            } finally {
                if (mounted) setshowSpinner(false);
            }
        };
        // only fetch when orgId is provided
        if (orgId !== undefined && orgId !== null) fetchData();
        return () => {
            mounted = false;
        };
    }, [orgId, filterObj, homeFlag, staffFlag])

    var orgStaffSummCols = [{
        dataField: 'orgId',
        sort: true,
        text: 'Org ID'
    }, {
        dataField: 'home_name',
        sort: true,
        text: 'Home'
    }, {
        dataField: 'home_status',
        sort: true,
        text: 'Home Status'
    }, {
        dataField: 'role_id',
        sort: true,
        text: 'Role ID'
    }, {
        dataField: 'role_name',
        sort: true,
        text: 'Role Name'
    }, {
        dataField: 'user_id',
        sort: true,
        text: 'User ID'
    }, {
        dataField: 'first_name',
        sort: true,
        text: 'First Name'
    }, {
        dataField: 'last_name',
        sort: true,
        text: 'Last Name'
    }
    , {
        dataField: 'type',
        sort: true,
        text: 'Course/Home Doc'
    },
        , {
        dataField: 'status',
        sort: true,
        text: 'Status'
    },
        , {
        dataField: 'is_complaint',
        sort: true,
        text: 'Is Compliant ?'
    },

    ];

    //  if (props.crsPolicyType=='11') {
    //     orgStaffSummCols.push({
    //     dataField: 'is_policy_complaint',
    //     sort: true,
    //     text: 'Is Policy Compliant ?'
    // });
    // }
    // if (props.crsPolicyType=='10') {
    //     orgStaffSummCols.splice(9, 1);
    //     orgStaffSummCols.push({
    //     dataField: 'is_policy_complaint',
    //     sort: true,
    //     text: 'Is Policy Compliant ?'
    // });
    // }

    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);

        // The application/octet-stream MIME type is used for unknown binary files.
        // It preserves the file contents, but requires the receiver to determine file type,
        // for example, from the filename extension.
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }

    //Excel
    const exportInExcel = async () => {
        try {
            var rowsCount = 6;
            const title = [{ A: 'CarePassport - Template Specific Summary for Organization ID : ' + String(orgId) }];
            let reportView = [{ A: 'Name', B: 'User ID', C: 'Role', D: 'Date' }];
            reportView.push({
                A: sessionStorage.getItem('fullName'),
                B: sessionStorage.getItem('userId'),
                C: (sessionStorage.getItem('userType') !== null) ? sessionStorage.getItem('userType').toUpperCase() : "User",
                D: new Date().toLocaleString()
            });
            reportView.push("");
            reportView.push("");
            var reportHeaders;
           
             reportHeaders = { A: 'Organization ID', B: 'Home Name', C: 'Home Status', D: 'Role ID', E: 'Role Name', F: 'User ID', G: 'First Name', H: 'Last Name',I:'Course/Home Doc', J: 'Status', K: 'Is Compliant?' };
            reportView.push(reportHeaders);
            // orgStaffTemplateData.forEach(element => {
            orgStaffSummData.forEach(element => {
                rowsCount += 1;
                var tempObj = {
                    A: element.orgId,
                    B: element.home_name,
                    C: element.home_status,
                    D: element.role_id,
                    E: element.role_name,
                    F: element.user_id,
                    G: element.first_name,
                    H: element.last_name,
                    I: element.type,
                    J: element.status,
                    K: element.is_complaint
                };
                reportView.push(tempObj);
            });
            
            // else if(crsPolicyType=='10'){
            //  reportHeaders = { A: 'Organization ID', B: 'Home Name', C: 'Home Status', D: 'Role ID', E: 'Role Name', F: 'User ID', G: 'First Name', H: 'Last Name', I: 'Status', J: 'Is Policy Compliant?' };
            // reportView.push(reportHeaders);
            // // orgStaffTemplateData.forEach(element => {
            // orgStaffSummData.forEach(element => {
            //     rowsCount += 1;
            //     var tempObj = {
            //         A: element.orgId,
            //         B: element.home_name,
            //         C: element.home_status,
            //         D: element.role_id,
            //         E: element.role_name,
            //         F: element.user_id,
            //         G: element.first_name,
            //         H: element.last_name,
            //         I: element.status,
            //         J: element.is_policy_complaint
            //     };
            //     reportView.push(tempObj);
            // });
            // }
            // else{
                
            //  reportHeaders = { A: 'Organization ID', B: 'Home Name', C: 'Home Status', D: 'Role ID', E: 'Role Name', F: 'User ID', G: 'First Name', H: 'Last Name', I: 'Status', J: 'Is Compliant?', K: 'Is Policy Compliant?' };
            // reportView.push(reportHeaders);
            // // orgStaffTemplateData.forEach(element => {
            // orgStaffSummData.forEach(element => {
            //     rowsCount += 1;
            //     var tempObj = {
            //         A: element.orgId,
            //         B: element.home_name,
            //         C: element.home_status,
            //         D: element.role_id,
            //         E: element.role_name,
            //         F: element.user_id,
            //         G: element.first_name,
            //         H: element.last_name,
            //         I: element.status,
            //         J: element.is_complaint,
            //         K: element.is_policy_complaint
            //     };
            //     reportView.push(tempObj);
            // });
            
            // }
            
            const finalData = [...title, ...reportView];
            const worksheet = XLSX.utils.json_to_sheet(finalData, {
                skipHeader: true,
            });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Template Specific Summary");
            const workbookblob = workbook2blob(workbook);
            var headerIndexes = [];
            finalData.forEach((data, index) =>
                data["A"] === "Organization ID" ? headerIndexes.push(index) : null
            );
            const dataInfo = {
                titleCell: "A2",
                titleRange: "A1:K1",
                tbodyRange: `A7:J${finalData.length}`,
                uHeadRange: `A2:D2`,
                uBodyRange: `A3:D3`,
                theadRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:J${headerIndexes[0] + 1}`
                        : null,
                theadRange1:
                    headerIndexes?.length >= 2
                        ? `A${headerIndexes[1] + 1}:I${headerIndexes[1] + 1}`
                        : null,
                tFirstColumnRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:A${rowsCount + headerIndexes[0] + 1}`
                        : null,
                tLastColumnRange:
                    headerIndexes?.length >= 1
                        ? `K${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[0] + 1}`
                        : null,

                tFirstColumnRange1:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[1] + 1}:A${rowsCount + headerIndexes[1] + 1}`
                        : null,
                tLastColumnRange1:
                    headerIndexes?.length >= 1
                        ? `H${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[1] + 1}`
                        : null,
            };
            XlsxPopulate.fromDataAsync(workbookblob).then((workbook) => {
                workbook.sheets().forEach((sheet) => {
                    sheet.column("A").width(15);
                    sheet.column("B").width(30);
                    sheet.column("C").width(20);
                    sheet.column("D").width(20);
                    sheet.column("E").width(30);
                    sheet.column("F").width(20);
                    sheet.column("G").width(30);
                    sheet.column("H").width(30);
                    sheet.column("I").width(20);
                    sheet.column("J").width(20);
                   
                    sheet.column("K").width(20);
                    
                    sheet.range(dataInfo.titleRange).merged(true).style({
                        bold: true,
                        fontFamily: "Arial",
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                    });
                    sheet.range(dataInfo.uHeadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    sheet.range(dataInfo.uBodyRange).style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tbodyRange) {
                        sheet.range(dataInfo.tbodyRange).style({
                            horizontalAlignment: "left",
                        });
                    }
                    sheet.range(dataInfo.theadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tFirstColumnRange) {
                        sheet.range(dataInfo.tFirstColumnRange).style({
                            bold: true,
                        });
                    }

                });

                return workbook.outputAsync().then((workbookBlob) => {
                    const downloadAnchorNode = document.createElement("a");
                    var dateVar = new Date();
                    var fileName = "Carepassport_OrgTemplateSpecificSummary-" + dateVar.getDate() + dateVar.getMonth() + dateVar.getFullYear() + "_" + dateVar.getHours() + dateVar.getMinutes() + ".xlsx";
                    downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                    downloadAnchorNode.setAttribute("download", fileName);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                    // setDataForSuccessPopup("Downloaded Successfully");
                    // setShowSuccessPopup(true);
                });
            });
        } catch (error) {
            setDataForErrorPopup("Something went wrong while processing excel!");
            setShowErrorPopup(true);
        }
    }


    return (
        <div>
            {showSpinner && (
                <div style={{ position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, background: "rgba(255,255,255,0.5)" }}>
                    <Spinner animation="border" size="lg" variant='primary' />
                </div>
            )}
            <Paper sx={{ p: 1, borderRadius: "1.5px" }}>
                {(!showSpinner && orgStaffSummData.length === 0) ? (
                    <Box sx={{ p: 6, textAlign: "center" }}>
                        <Typography variant="h6" gutterBottom>No data available</Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            There are no template-specific records for the selected organization / filters.
                        </Typography>
                        <Button variant="outlined" onClick={() => {
                            // quick manual retry, trigger fetch by toggling orgId (or call same fetch routine)
                            setshowSpinner(true);
                            // re-run effect by calling an empty state update; simplest is to setOrgStaffSummData to same to trigger rerender
                            setOrgStaffSummData([]);
                            setTimeout(() => setshowSpinner(false), 300); // UX: brief feedback if no network
                        }}>Retry</Button>
                    </Box>
                ) : (
                    <BootstrapTable id='organizationStaffSpecificTable' keyField='id' data={orgStaffSummData} columns={orgStaffSummCols} striped hover />
                )}
                <Row>
                    <Col xs={0} md={8}>

                    </Col>
                    <Col xs={12} md={4} className="text-center">
                        <Paper component="form" variant="outlined"
                            sx={{ float: "right", display: 'flex', marginBottom: "4px", alignItems: 'center', width: 50 }}
                        >

                            <Tooltip variant="contained" title="Export to Excel" disableRipple>
                                <IconButton color="primary" onClick={exportInExcel} sx={{ p: '10px' }} aria-label="directions">
                                    <RiFileExcel2Line />
                                </IconButton>
                            </Tooltip>
                        </Paper>
                    </Col>
                </Row>
            </Paper>
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false) }} />
        </div>


    )
}

export default OrganizationTemplateSpecificComponent